module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0088.jpg?v=06278b41";